import styled from 'styled-components/macro';

export const LoginPageStyled = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;
